
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticStyle:{"isolation":"isolate"},attrs:{"data-name":"Path 445","d":"M32 60.8C14.8 49.3 5.77 38.84 2.07 30.08-7.85 6.61 20.47-4.61 32 9.24 43.53-4.61 71.85 6.61 61.93 30.08 58.23 38.84 49.2 49.3 32 60.8z"}})])
          )
        }
      }
    